import { Box, Link, makeStyles } from '@material-ui/core';
import React, { ReactNode } from 'react';

import { CONSTANTS } from '../../../core/config/constants';
import { FontSizes } from '../../../core/config/mainTheme';
import { fixLink } from '../../../core/utils/link.utils';

interface Props {
  label: string;
  value?: string | number;
  values?: string[];
  isLink?: boolean;
  children?: ReactNode;
}

const ContentBlockParam: React.FC<Props> = ({ label, value, values, children, isLink = false }) => {
  const classes = useStyles();

  let content;
  if (value) {
    content = isLink ? (
      <Link className={classes.link} href={`${fixLink(value)}`} target="_blank">
        {value}
      </Link>
    ) : (
      value
    );
  } else if (values) {
    if (isLink && values.length > 0) {
      content = values.map((v) => (
        <Link className={classes.link} href={`${fixLink(v)}`} target="_blank" key={v}>
          {v}
        </Link>
      ));
    } else if (values.length <= 0) {
      content = CONSTANTS.EMPTY_VALUE;
    } else {
      content = values.join('\n');
    }
  } else {
    content = CONSTANTS.EMPTY_VALUE;
  }

  return (
    <>
      <Box className={classes.label}>{label}</Box>
      <Box className={classes.value}>{content} </Box>
      {children}
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  label: {
    textTransform: 'uppercase',
    fontSize: FontSizes.size.small,
    color: theme.palette.grey[500],
  },
  value: {
    fontSize: FontSizes.size.medium,
    color: theme.palette.grey[900],
    wordBreak: 'break-all',
    whiteSpace: 'pre-line',
  },
  link: {
    display: 'block',
  },
}));

export default ContentBlockParam;
